export default "__VITE_ASSET__DWkvsxPG__"